import React, { PureComponent } from 'react';
import 'eventsource-polyfill';
import { getUser } from '../../services/auth';
import '../../css/tvCSS/style.css';
import api from '../../services/api';
import sound from './call_sound.mp3';
import webstomp from 'webstomp-client';
import SockJS from 'sockjs-client';

webstomp.debug = null;

export default class Painel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      senhaAtual: {
        local: '',
        atendente: '',
        cliente: '',
      },
      senhasAnteriores: [],
      dataAtual: '',
      anoAtual: '',
      horaAtual: '',
      webSocketConnected: false,
      client: null,
    };
  }

  atualizarDataHora = () => {
    const dataAtual = new Date();
    const dataFormatada = dataAtual.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
    }); // Formato dd/MM
    const anoFormatado = dataAtual.getFullYear(); // Extraindo o ano
    const horaFormatada = dataAtual.toLocaleTimeString(); // Formato de hora local
    this.setState({
      dataAtual: dataFormatada,
      anoAtual: anoFormatado,
      horaAtual: horaFormatada,
    });
  };

  connectAndReconnect = () => {
    if (this.state.client == null) {
      console.log('Connect and reconnect');
      let sock = new SockJS(window.IP_SERVER_WS);
      console.log('sock');
      console.log(sock);
      let client = webstomp.over(sock);
      console.log(client);
      this.setState({ client }, () => {
        client.connect(
          {},
          (frame) => {
            console.log(3);
            this.successCallback(client);
          },
          (error) => {
            console.log('error');
            this.errorCallback(error);
            setTimeout(() => {
              // this.connectAndReconnect();
            }, 5000);
          }
        );
      });
    } else {
      console.log('Já tem client');
    }
  };

  successCallback = (client) => {
    console.log('successCallback');
    // this.props.clearMedico();
    // this.props.clear();
    this.setState({ client, webSocketConnected: true }, () => {});
    const estabelecimento = getUser().estabelecimento;
    client.subscribe(
      '/topic/senhas/' + estabelecimento.cpfCnpj,
      this.handleDataUpdate
    );
    // this.props.conectSocket({ client, webSocketConnected: true });
    // this.conectChanels(client);
    // this.conectChanelsIndisponibilidade(client);
  };

  handleDataUpdate = (messageOutput: any) => {
    console.log('handleDataUpdate');
    let senha = JSON.parse(messageOutput.body);
    this.updateSenhas(senha);
  };

  updateSenhas = (senha) => {
    console.log('updateSenhas');
    this.audioRef.play();
    this.setState((prevState) => {
      const senhasAnteriores = [
        this.state.senhaAtual,
        ...prevState.senhasAnteriores,
      ].slice(0, 3);

      return {
        senhaAtual: senha,
        senhasAnteriores,
      };
    });
  };

  errorCallback = (error) => {
    console.log(error);
    this.setState({ webSocketConnected: false });
    // this.props.disconectSocket();
  };

  connect = () => {
    const estabelecimento = getUser().estabelecimento;
    const ws = new WebSocket(`wss://painelws.sasccm.coop.br/ws`);

    ws.onopen = () => {
      // Ao abrir a conexão WebSocket, você pode enviar uma mensagem para autenticação ou realizar outras ações, se necessário.
      console.log('WebSocket connection opened');
      ws.send(JSON.stringify({ cnpjEstabelecimento: estabelecimento.cpfCnpj }));
    };

    ws.onmessage = (event) => {
      console.log(event);
      const data = JSON.parse(event.data);

      if (data.type === 'ping') {
        console.log('ping');
        return;
      }

      const senha = data.payload;
      console.log(this.audioRef);
      this.audioRef.play();

      this.setState((prevState) => {
        const senhasAnteriores = [
          this.state.senhaAtual,
          ...prevState.senhasAnteriores,
        ].slice(0, 3);

        return {
          senhaAtual: senha,
          senhasAnteriores,
        };
      });
    };

    ws.onerror = (error) => {
      console.error('WebSocket failed:', error);

      if (error.status === 403) {
        console.log('Access denied. Check permissions.');
      } else {
        // Handle other types of errors
      }

      // Close the connection
      ws.close();
    };

    ws.onclose = (event) => {
      console.log('Connection closed:', event);

      // Try to reconnect after 5 seconds
      setTimeout(() => {
        this.connect();
      }, 5000);
    };

    // Close the existing connection if it exists
    if (this.state.ws) {
      this.state.ws.close();
    }

    this.setState({ ws });
  };

  componentDidMount() {
    this.connectAndReconnect();
    this.getSenhas();
    this.atualizarDataHora();
    this.intervalo = setInterval(this.atualizarDataHora, 1000);
  }
  getSenhas = () => {
    api.get('/senha/all').then(
      (r) => {
        if (r.data && r.data.length > 0) {
          const senhasAnteriores = r.data.slice(1, 4);
          this.setState((prevState) => ({
            senhaAtual: r.data[0],
            senhasAnteriores,
          }));
        }
      },
      (erro) => {
        console.log('erro do senha All');
        console.log(erro);
      }
    );
  };

  render() {
    const estabelecimento = getUser().estabelecimento;
    return (
      <>
        <audio id="audio" autoPlay ref={(ref) => (this.audioRef = ref)}>
          <source src={sound} type="audio/mpeg" />
          <source src="./call_sound.ogg" type="audio/ogg; codecs=vorbis" />
        </audio>

        <div className="top d-flex justify-content-between align-items-center">
          <div>
            <h2 id="dataAtual">{this.state.dataAtual}</h2>
            <h2 className="year" id="anoAtual">
              {this.state.anoAtual}
            </h2>
          </div>
          <h1 id="nomeEstabelecimento">{estabelecimento.nome}</h1>
          <h2 id="horaAtual">{this.state.horaAtual}</h2>
        </div>
        {/* Restante da estrutura permanece igual */}

        <div className="ON callAnimate" id="painelAnimado">
          {this.state.senhaAtual && (
            <div
              className="chamada d-flex flex-column align-items-center justify-content-center"
              id="current"
            >
              <div className="txtPaciente" id="currentPaciente">
                {this.state.senhaAtual.cliente}
              </div>
              {this.state.senhaAtual.prefixFila && (
                <div className="txtSenha" id="currentSenha">
                  Senha:{' '}
                  {this.state.senhaAtual.prefixFila +
                    '-' +
                    this.state.senhaAtual.number}
                </div>
              )}

              <div className="txtSala" id="currentLocal">
                {this.state.senhaAtual.local}
              </div>
              <div className="txtProfissional" id="currentProfissional">
                <i>{this.state.senhaAtual.atendente}</i>
              </div>
            </div>
          )}

          <div
            className="atendimentosAnteriores d-flex justify-content-center row"
            id="atendimentosAteriores"
          >
            {this.state.senhasAnteriores.map((senha, index) => (
              <div key={index} className="itemAnterior col">
                <div className="txtPaciente" id="senhaAnteriorPaciente">
                  {senha.cliente}
                </div>
                <div className="txtSala" id="senhaAnteriorLocal">
                  {senha.local}
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }
}
